import { IoMdClose } from 'react-icons/io'
import * as styled from './styled'

type FilterLayoutProps = {
	title: string
	onApply: () => void
	onReset: () => void
	onClose: () => void
	selectedCount: number
	children: React.ReactNode
}

const FilterLayout: React.FC<FilterLayoutProps> = ({
	title,
	onApply,
	onReset,
	onClose,
	selectedCount,
	children,
}) => (
	<>
		<styled.Overlay
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		/>
		<styled.Drawer
			role='dialog'
			initial={{ x: '100%' }}
			animate={{ x: 0 }}
			exit={{ x: '100%' }}
			transition={{ duration: 0.3, ease: 'easeOut' }}
		>
			<styled.FiltersWrap>
				<styled.Title>
					<div>
						{title}{' '}
						{selectedCount > 0 && (
							<styled.SelectedCount>({selectedCount})</styled.SelectedCount>
						)}
					</div>
					<IoMdClose size={30} color='#01924f' onClick={onClose} />
				</styled.Title>

				{children}

				<styled.Actions>
					<styled.FilterButton onClick={onApply}>
						Застосувати
					</styled.FilterButton>

					<styled.FilterButton $variant="outline" onClick={onReset}>
						Скасувати
					</styled.FilterButton>
				</styled.Actions>
			</styled.FiltersWrap>
		</styled.Drawer>
	</>
)
export default FilterLayout